//请求方式的封装
import axios from 'axios';
import router from '../router/index.js'
import {
  Message
} from 'element-ui'
//http request 拦截器
axios.interceptors.request.use(
  config => {
    config.headers.get['content-type'] = 'application/x-www-form-urlencoded'
    const token = sessionStorage.getItem("token");
    if (token) {
      config.headers.common['Authorization'] = token
    }
    return config;

  },
  error => {

    router.push({
      path: "/login"
    })
    return Promise.reject(err);
  }
);
axios.interceptors.response.use(
  response => {
    return response;
  },
  error => {
    if (error.response.status == "401") {
      Message.error("token 登录失效，重新登录")
      router.push({
        path: "/login"
      })


    }
    return Promise.reject(error)
  }
)
/**
 * 封装get方法
 * @param url
 * @param data
 * @returns {Promise}
 */
export function fetch(url, params = {}) {
  return new Promise((resolve, reject) => {
    axios.get(url, {
        params: params
      })
      .then(response => {
        resolve(response.data);
      })
      .catch(err => {
        reject(err)
      })
  })
}

export function fetch2(url, params = {}) {

  return new Promise((resolve, reject) => {
    // let config = {
    //     headers: {
    //         "Accept":"text/html,application/xhtml+xml,application/xml;q=0.9,*/*;q=0.8",
    //         "contentType": "application/x-www-form-urlencoded",
    //         'User-Agent': "Mozilla/5.0 (Linux; Android 6.0; Nexus 5 Build/MRA58N) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/92.0.4515.107 Mobile Safari/537.36 Edg/92.0.902.55"
    //     }
    // };
    axios.get(url, {
        params: params,
        // responseType: 'blob'
      })
      .then(response => {
        resolve(response);
      })
      .catch(err => {
        reject(err)
      })
  })
}
export function fetch3(url, params = {}) {
  return new Promise((resolve, reject) => {
    axios.get(url, {
        params: params,
        responseType: 'arraybuffer'
      })
      .then(response => {
        let val = 'data:image/png;base64,' + btoa(new Uint8Array(response.data).reduce((data, byte) => data +
          String.fromCharCode(byte), ''))
        resolve(val);
      })
      .catch(err => {
        reject(err)
      })
  })
}

export function post2(url, par, config) {
  return new Promise((resolve, reject) => {
    axios.post(url, par, config)
      .then(response => {
        resolve(response.data);
      }, err => {
        reject(err)
      })
  })
}
/**
 * 封装post请求
 * @param url
 * @param data
 * @returns {Promise}
 */
export function post(url, params) {
  return new Promise((resolve, reject) => {
    let config = {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    };
    axios.post(url, params, config)
      .then(response => {
        resolve(response.data);
      }, err => {
        reject(err)
      })
  })
}
export function postExport(url, params) {

  return new Promise((resolve, reject) => {
    //   axios({
    //     method: 'post',
    //     data: {
    //       idArr: params
    //     },
    //     responseType: 'blob'
    //   }).then(response => {
    //     resolve(response.data);
    //   }, err => {
    //     reject(err)
    //   })
    // })
    let config = {
          responseType: 'blob'
      };
      axios.post(url, params, config)
        .then(response => {
          resolve(response.data);
        }, err => {
          reject(err)
        })
    })



  }
  /**
   * 封装上传upload请求
   * @param url
   * @param data
   * @returns {Promise}
   */
  export function upload(url, formData) {
    return new Promise((resolve, reject) => {
      let config = {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      };
      axios.post(url, formData, config)
        .then(response => {
          resolve(response.data);
        }, err => {
          reject(err)
        })
    })
  }
  export function upload2(url, formData, formData2, config) {
    return new Promise((resolve, reject) => {
      axios.post(url, formData, formData2, config)
        .then(response => {
          resolve(response.data);
        }, err => {
          reject(err)
        })
    })
  }
  /**
   * 封装patch请求
   * @param url
   * @param data
   * @returns {Promise}
   */
  export function patch(url, data = {}) {
    return new Promise((resolve, reject) => {
      axios.patch(url, data)
        .then(response => {
          resolve(response.data);
        }, err => {
          reject(err)
        })
    })
  }
  /**
   * 封装put请求
   * @param url
   * @param data
   * @returns {Promise}
   *   div
   */
  export function put(url, data = {}) {
    return new Promise((resolve, reject) => {
      axios.put(url, data)
        .then(response => {
          resolve(response.data);
        }, err => {
          reject(err)
        })
    })
  }



// WEBPACK FOOTER //
// ./src/api/request.js